<div
  class="flex justify-content-around flex-wrap h-screen align-content-center">
  <form [formGroup]="setPasswordForm" (ngSubmit)="onSubmit()">
    <p-card styleClass="w-30rem">
      <ng-template pTemplate="title">
        <i class="fas fa-user-lock"></i> Passwort festlegen
      </ng-template>
      <ng-template pTemplate="content">
        <p-messages
          *ngIf="false"
          [(value)]="messages"
          [enableService]="false"
          [closable]="false"></p-messages>

        <div class="flex flex-column gap-3">
          <label for="password">Passwort</label>
          <input
            type="password"
            id="password"
            formControlName="password"
            pInputText />

          <label for="passwordRepeat">Passworteingabe wiederholen</label>
          <input
            type="password"
            id="passwordRepeat"
            formControlName="passwordRepeat"
            pInputText />
        </div>
      </ng-template>
      <ng-template pTemplate="footer">
        <p-button
          [loading]="loading"
          [rounded]="true"
          icon="fas fa-check-circle"
          label="absenden"
          type="submit">
        </p-button>
      </ng-template>
    </p-card>
  </form>
</div>
